import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { getI18NLabelFromFolderType } from '../data/constants/SearchContentTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const IndexTableHeaderCheckboxCell = ({
  checked,
  disabled,
  folderContentType,
  indeterminate,
  toggleSelection
}) => {
  return /*#__PURE__*/_jsx("th", {
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Checkbox, {
        "data-selenium-test": "index-header-checkbox",
        "aria-label": getI18NLabelFromFolderType(folderContentType),
        checked: checked,
        indeterminate: indeterminate,
        disabled: disabled,
        onChange: toggleSelection
      })
    })
  });
};
export default IndexTableHeaderCheckboxCell;